import type { DialPadVariant } from 'features/dial-pad/enums';
import { DialPadLocalStorageKey } from 'features/dial-pad/enums';

export const setDialPadVariantInLocalStorage = (
  dialPadVariant: DialPadVariant
) => {
  localStorage.setItem(DialPadLocalStorageKey.DIAL_PAD_VARIANT, dialPadVariant);
};

export const getDialPadVariantFromLocalStorage = (): DialPadVariant => {
  return localStorage.getItem(
    DialPadLocalStorageKey.DIAL_PAD_VARIANT
  ) as DialPadVariant;
};
